import { useEffect, useState } from "react";
import * as APIModels from "../../../../models";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

export default function ServiceContactUpdateModal(params: {
    close: () => void;
    addServiceContactModal: boolean;
    updateServiceContact: (u: APIModels.ServiceContact) => Promise<boolean>;
    updating: APIModels.ServiceContact;
    message: string;
}): JSX.Element {
    const [message, setMessage] = useState<string>("");
    const [model, setModel] = useState<APIModels.ServiceContact>({
        ...params.updating,
    });

    useEffect(() => {
        setMessage(params.message);
    }, [params.updating, params.message]);

    const send = async () => {
        const copy = { ...model } as APIModels.ServiceContact;
        copy.address!.fullAddress =
            model.address!.streetAddress! + model.address?.unit !== null
                ? ", " + model.address!.unit
                : "" +
                  ", " +
                  model.address!.city +
                  ", " +
                  model.address!.state +
                  ", " +
                  model.address!.zip;
        copy.active = true;

        const result = await params.updateServiceContact(copy);
        if (result) {
            params.close();
        } else {
            setMessage("Failed to add Service Contact");
        }
    };

    return (
        <div>
            <Modal show={params.addServiceContactModal}>
                <Form>
                    <Modal.Header>
                        <Modal.Title style={{ color: "Blue" }}>
                            Update a Service Contact
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group as={Row}>
                            <Form.Group as={Col}>
                                <Form.Label>First Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="First Name"
                                    value={model.firstName}
                                    onChange={(e) => {
                                        setModel({
                                            ...model,
                                            firstName: e.target.value,
                                        });
                                    }}
                                />
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>Middle Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Middle Name"
                                    value={model.middleName}
                                    onChange={(e) => {
                                        setModel({
                                            ...model,
                                            middleName: e.target.value,
                                        });
                                    }}
                                />
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Last Name"
                                    value={model.lastName}
                                    onChange={(e) => {
                                        setModel({
                                            ...model,
                                            lastName: e.target.value,
                                        });
                                    }}
                                />
                            </Form.Group>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Group as={Col}>
                                <Form.Label>Contact Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Contact Email"
                                    value={model.emailAddress}
                                    onChange={(e) => {
                                        setModel({
                                            ...model,
                                            emailAddress: e.target.value,
                                        });
                                    }}
                                />
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>Case Number</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Case Number"
                                    disabled
                                    value={model.caseNumber}
                                    onChange={(e) => {
                                        setModel({
                                            ...model,
                                            caseNumber: e.target.value,
                                        });
                                    }}
                                />
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>User Type</Form.Label>
                                <Form.Control
                                    disabled
                                    type="text"
                                    placeholder="User Type"
                                    value={model.userType}
                                    onChange={(e) => {
                                        setModel({
                                            ...model,
                                            userType: e.target.value,
                                        });
                                    }}
                                />
                            </Form.Group>
                        </Form.Group>
                        <div
                            style={{
                                margin: "0.5em",
                            }}
                        >
                            <Form.Label column sm={2}>
                                Address
                            </Form.Label>
                            <Form.Group as={Row}>
                                <Form.Group as={Col}>
                                    <Form.Label>Address Line 1</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="123 Main St"
                                        value={
                                            model.address!.streetAddress ?? ""
                                        }
                                        onChange={(e) => {
                                            const prev =
                                                model.address ??
                                                ({} as APIModels.IAddress);
                                            prev.streetAddress =
                                                e.target.value ?? "";
                                            setModel({
                                                ...model,
                                                address: prev,
                                            });
                                        }}
                                    />
                                </Form.Group>
                                <Form.Group as={Col}>
                                    <Form.Label>
                                        Address Line 2 (Unit)
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Unit 456"
                                        value={model.address!.unit ?? ""}
                                        onChange={(e) => {
                                            const prev =
                                                model.address ??
                                                ({} as APIModels.IAddress);
                                            prev.unit = e.target.value ?? "";
                                            setModel({
                                                ...model,
                                                address: prev,
                                            });
                                        }}
                                    />
                                </Form.Group>
                                <Form.Group as={Col}>
                                    <Form.Label>City</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Cityville"
                                        value={model.address!.city ?? ""}
                                        onChange={(e) => {
                                            const prev =
                                                model.address ??
                                                ({} as APIModels.IAddress);
                                            prev.city = e.target.value ?? "";
                                            setModel({
                                                ...model,
                                                address: prev,
                                            });
                                        }}
                                    />
                                </Form.Group>
                            </Form.Group>
                            <Form.Group as={Row}>
                                <Form.Group as={Col}>
                                    <Form.Label>State</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="TX"
                                        value={model.address!.state ?? ""}
                                        disabled
                                    />
                                </Form.Group>
                                <Form.Group as={Col}>
                                    <Form.Label>Zip</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="12345"
                                        value={model.address!.zip ?? ""}
                                        onChange={(e) => {
                                            const prev =
                                                model.address ??
                                                ({} as APIModels.IAddress);
                                            prev.zip = e.target.value ?? "";
                                            setModel({
                                                ...model,
                                                address: prev,
                                            });
                                        }}
                                    />
                                </Form.Group>
                                <Form.Group as={Col}></Form.Group>
                            </Form.Group>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        {message && message != "" ? (
                            <p style={{ color: "red", float: "none" }}>
                                {message}
                            </p>
                        ) : (
                            <></>
                        )}
                        <button
                            type="submit"
                            className="btn btn-success"
                            onClick={async (e) => {
                                e.preventDefault();
                                await send();
                            }}
                            style={{ float: "left" }}
                        >
                            <i className="" /> Update
                        </button>
                        <Button
                            variant="secondary"
                            onClick={() => params.close()}
                            style={{ float: "right" }}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
}
